import ItemWhModal from '../Modal/ItemWhModal';
import { formatCurrency } from '../../../utils/SamuiUtils';

const ItemWhTable = ({
  mode,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  formDetailList,
  handleItemShow,
  handleQuantityChange,
  handleFocus,
  handleBlur,
  handleRemoveRow,
  disabled,
  showRemarkColumn = false,
  handleRemarkChange = () => {},
}) => {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title">รายละเอียดสินค้า</h4>
        <button
          hidden={window.location.pathname === '/product-delivery' ? true : false}
          className="btn text-white mx-3"
          onClick={handleItemShow}
          style={{
            backgroundColor: 'rgb(239, 108, 0)',
            whiteSpace: 'nowrap',
            padding: '10px',
            fontSize: '15px'
          }}
          disabled={disabled}
        >
          <i className="fa fa-plus"></i> เพิ่มรายการ
        </button>
      </div>
      <ItemWhModal
        formDetailList={formDetailList}
        showItemModal={showItemModal}
        handleItemClose={handleItemClose}
        itemDataList={itemDataList}
        onRowSelectItem={onRowSelectItem}
      />
      <div className="card-body">
        <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          <table id="basic-datatables" className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th className="text-center" style={{ width: '2%' }}>#</th>
                <th className="text-center" style={{ width: '8%' }}>รหัสสินค้า</th>
                <th
                  className="text-center"
                  style={mode === 'FA' ? { width: '28%' } : { width: '35%' }}
                >
                  ชื่อสินค้า
                </th>
                {showRemarkColumn && (
                  <th className="text-center" style={{ width: '12%' }}>
                    หมายเหตุ
                  </th>
                )}
                <th className="text-center" style={{ width: '10%' }}>Todo</th>
                <th className="text-center" style={{ width: '10%' }}>จำนวนคงคลัง</th>

                {window.location.pathname === '/product-delivery' && (
                  <>
                    <th className="text-center" style={{ width: '10%' }}>จำนวนใบขาย</th>
                    <th className="text-center" style={{ width: '10%' }}>จำนวนค้างส่ง</th>
                  </>
                )}

                {mode === 'FA' ? (
                  <>
                    <th className="text-center" style={{ width: '10%' }}>เพิ่ม</th>
                    <th className="text-center" style={{ width: '10%' }}>ลด</th>
                  </>
                ) : (
                  <th className="text-center" style={{ width: '10%' }}>จำนวน{window.location.pathname === '/picking-list'
                    || window.location.pathname === '/bill-of-lading' ? 'เบิก' : ''}</th>
                )}

                {window.location.pathname !== '/product-delivery' && (
                  <th className="text-center" style={{ width: '10%' }}>จำนวนคงเหลือ</th>
                )}

                <th className="text-center" style={{ width: '5%' }}>หน่วย</th>
                <th className="text-center" style={{ width: '5%' }}>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {formDetailList.length > 0 ? (
                formDetailList.map((item, index) => (
                  <tr key={item.itemId || index + 1}>
                    {/* # */}
                    <td className="text-center">{index + 1}</td>

                    {/* รหัสสินค้า */}
                    <td className="text-center">
                      <span>{item.itemCode || ''}</span>
                    </td>

                    {/* ชื่อสินค้า */}
                    <td className="text-left">
                      <span>{item.itemName || ''}</span>
                    </td>

                    {/* หมายเหตุ */}
                    {showRemarkColumn && (
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={item.itemDesc || ''}
                          onChange={(e) => handleRemarkChange(index, e.target.value)}
                          disabled={disabled}
                        />
                      </td>
                    )}

                    {/* Todo */}
                    <td className="text-center">
                      <span>{item.docType || ''}</span>
                    </td>

                    {/* จำนวนคงคลัง */}
                    <td className="text-center">
                      <span>{item.itemOnHand || 0}</span>
                    </td>

                    {window.location.pathname === '/product-delivery' && (
                      <>
                        <td className="text-center">
                          <span>{formatCurrency(item.itemQty || 0)}</span>
                        </td>
                        <td className="text-center">
                          <span>{formatCurrency(item.itemRecQty || 0)}</span>
                        </td>
                      </>
                    )}

                    {mode === 'FA' ? (
                      <>
                        {/* เพิ่ม */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemIncrease || ''}
                            onChange={(e) => handleQuantityChange(index, 'increase', e.target.value, item.itemOnHand)}
                            onFocus={(e) => handleFocus(index, 'itemIncrease')}
                            onBlur={(e) => handleBlur(index, 'itemIncrease', e.target.value)}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                          />
                        </td>

                        {/* ลด */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemDecrease || 0}
                            onChange={(e) => handleQuantityChange(index, 'decrease', e.target.value, item.itemOnHand)}
                            onFocus={(e) => handleFocus(index, 'itemDecrease')}
                            onBlur={(e) => handleBlur(index, 'itemDecrease', e.target.value)}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        {/* จำนวน */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemDecrease || ""}
                            onChange={(e) => handleQuantityChange(index, 'decrease', e.target.value, item.itemOnHand)}
                            onFocus={() => handleFocus(index)}
                            onBlur={() => handleBlur(index)}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                            disabled={window.location.pathname === '/icebox' ? true : false}
                          />
                        </td>
                      </>
                    )}

                    {/* จำนวนคงเหลือ */}
                    {window.location.pathname !== '/product-delivery' && (
                      <td className="text-center">
                        <span>{formatCurrency(item.itemBalance) || 0}</span>
                      </td>
                    )}

                    {/* หน่วย */}
                    <td className="text-center">
                      <span>{item.itemUnit || ''}</span>
                    </td>

                    {/* ลบ */}
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleRemoveRow(index)}>
                        ลบ
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10">
                    <center>
                      <h5>ไม่พบรายการสินค้า</h5>
                    </center>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div >
  );
};

export default ItemWhTable;
